import { call, put, takeEvery } from 'redux-saga/effects';
import * as actions from './_actions';
import * as types from './_actionTypes';

function* fetchCollegeDashboardSaga() {
  try {
    const mockData = {
      stats: {
        totalStudents: 1250,
        activeStudents: 980,
        completedCourses: 456,
        certificatesIssued: 378,
        averageScore: 76
      },
      recentActivities: [
        { id: 1, type: 'enrollment', message: '15 new students enrolled today', time: '2 hours ago' },
        { id: 2, type: 'completion', message: '8 students completed Computer Science course', time: '4 hours ago' },
        { id: 3, type: 'certificate', message: '12 certificates issued', time: '1 day ago' }
      ]
    };
    
    yield put(actions.fetchCollegeDashboardSuccess(mockData));
  } catch (error) {
    yield put(actions.fetchCollegeDashboardFailure(error.message));
  }
}

function* fetchCollegeAnalyticsSaga() {
  try {
    const mockAnalytics = {
      enrollmentTrend: [45, 52, 48, 61, 55, 67],
      completionRate: 78,
      subjectWiseProgress: [
        { subject: 'Computer Science', enrolled: 450, completed: 320 },
        { subject: 'Mathematics', enrolled: 380, completed: 290 },
        { subject: 'Physics', enrolled: 420, completed: 310 }
      ]
    };
    
    yield put(actions.fetchCollegeAnalyticsSuccess(mockAnalytics));
  } catch (error) {
    yield put(actions.fetchCollegeAnalyticsFailure(error.message));
  }
}

function* collegeDashboardSaga() {
  yield takeEvery(types.FETCH_COLLEGE_DASHBOARD_REQUEST, fetchCollegeDashboardSaga);
  yield takeEvery(types.FETCH_COLLEGE_ANALYTICS_REQUEST, fetchCollegeAnalyticsSaga);
}

export default collegeDashboardSaga;